import { render, staticRenderFns } from "./BlogEdit.vue?vue&type=template&id=35430117&"
import script from "./BlogEdit.vue?vue&type=script&lang=js&"
export * from "./BlogEdit.vue?vue&type=script&lang=js&"
import style0 from "./BlogEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports